export function isValidBase64ImageData(base64Data) {
	// Regular expression for base64 format
	const base64Pattern = /^data:image\/(png|jpg|jpeg|gif);base64,[A-Za-z0-9+/]+={0,2}$/;
	// Test if the string matches the pattern
	return base64Pattern.test(base64Data);
}
